import {Chip} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";


const ChipCompleted = () => {
    return (
        <Chip label='Anexado' color='success' variant='filled' size='small' avatar={<CheckIcon sx={{color: 'white !important'}}/>}/>
    )
}


export default ChipCompleted